module.exports = __webpack_public_path__ + "static/media/ellenerica.a6cfa06c.png";